import BaseContainer from "@base/container/BaseContainer";
import {Signals} from "@/Imports";
import ParallaxLayer from "./ParallaxLayer";
import Utils from "@base/utils/Utils";
import gsap from "gsap";

export default class ParallaxContainer extends BaseContainer {

  constructor() {
    super()

    // Block Size: 2450 * 604
    // Static (max) layer width is 2450 * 3
    this.settings = {
      speed: 3.3,
      layers: [
        {
          name: 'Back layer with slow background rocks',
          speedMultiplier: 0.25,
          gap: 50,
          objects: Utils.shuffle([
            {name: 'backElem_1', y: 436, scale: 0.5, },
            {name: 'backElem_3', y: 500, scale: 0.5, },
            {name: 'backElem_4', y: 480, scale: 0.5, },
            {name: 'backElem_5', y: 484, scale: 0.5, },
            {name: 'backElem_6', y: 484, scale: 0.5, },
            {name: 'backElem_7', y: 433, scale: 0.5, },
            {name: 'backElem_8', y: 390, scale: 1, },
          ]),
        },
        {
          name: 'Middle layer with big background images',
          speedMultiplier: 1,
          type: 'animation',
          gap: 0,
          objects: Utils.shuffle([
            {
              name: 'parallax/bgSecA',
              repeat: true,
              animations: ['bgSecA'],
              scale: 0.5,
              y: 281
            },
            {
              name: 'parallax/bgSecB',
              repeat: true,
              animations: ['bgSecB'],
              scale: 0.5,
              y: 281
            },
            {
              name: 'parallax/bgSecC',
              repeat: true,
              animations: ['bgSecC'],
              scale: 0.5,
              y: 281
            },
            {
              name: 'parallax/bgSecD',
              repeat: true,
              animations: ['bgSecA'],
              scale: 0.5,
              y: 281
            },
          ])
        },
        {
          name: 'Front layer with front mountains',
          speedMultiplier: 6,
          gap: 500,
          objects: Utils.shuffle([
            {name: 'frontElem_1', y: 496},
            {name: 'frontTree', y: 400, scale: 0.5},
            {name: 'frontTreeDark', y: 400},
            {name: 'frontElem_1', y: 496},
            {name: 'frontTree', y: 400, scale: 0.5},
            {name: 'frontTreeDark', y: 400},
            {name: 'frontTreeDark', y: 400},
          ]),
        },
      ]
    }

    this.parallax = new PIXI.Container()
    this.parallax.name = "Parallax"

    this.addChild(this.parallax)

    this.init(this.settings)
  }

  init(settings) {
    Signals.makeBets.add(this.onMakeBets, this)
    Signals.roundStart.add(this.onRoundStart, this)
    Signals.roundEnd.add(this.onRoundEnd, this)

    this.layers = settings.layers.map((layerSetting, i) => {
      const layer = new ParallaxLayer(layerSetting, settings)
      this.parallax.addChild(layer)
      return layer
    })
  }

  reset() {
    this.layers.forEach(layer => layer.reset())
  }

  update() {
    this.layers.forEach(layer => layer.move())
  }

  slowDown() {
    return new Promise((resolve, reject) => {
      let speedBreak = 1;
      let interval = 0;

      interval = setInterval(() => {
        if (speedBreak <= 0) {
          clearInterval(interval)
          resolve()
        }
        speedBreak -= 0.011
        this.layers.forEach(layer => layer.move(speedBreak))
      }, 26)
    });
  }

  onMakeBets() {
    Signals.tick.remove(this.update, this)

    this.reset()
  }

  onRoundEnd() {
    Signals.tick.remove(this.update, this)
    this.slowDown().then(() => { })
  }

  onRoundStart() {
    this.reset()

    Signals.tick.add(this.update, this)
  }
}
